export default "__VITE_ASSET__c19853a5__"